<script>
	import config from '@/config.js';

	export let proxy;

	let url = `${config.PHONE_BET_URL}?proxy=${proxy}`;
</script>

{#if proxy}
	<iframe src={url} width="100%" height="100%" title="Wagering" border="0" />
{:else}
	<div class="py-10 text-xl text-center text-red-500 uppercase bg-light">
		Not authorised to place bets on behalf of this user!
	</div>
{/if}
